// Admin Portal Configuration //
// Centralized configuration for environment-specific settings

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:7071/api',
  environment: import.meta.env.VITE_ENVIRONMENT || 'local',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

// API endpoint builders
export const apiEndpoints = {
  // Authentication
  auth: {
    login: `${config.apiBaseUrl}/auth/login`,
    logout: `${config.apiBaseUrl}/auth/logout`,
    refresh: `${config.apiBaseUrl}/auth/refresh`,
  },
  
  // Admin Support
  adminSupport: {
    systemHealth: `${config.apiBaseUrl}/TCAdminSupport/system-health`,
    customers: `${config.apiBaseUrl}/TCAdminSupport/customers`,
    deployments: `${config.apiBaseUrl}/TCAdminSupport/deployments`,
  },
  
  // Customers
  customers: {
    list: `${config.apiBaseUrl}/customers`,
    detail: (id: string) => `${config.apiBaseUrl}/customers/${id}`,
    create: `${config.apiBaseUrl}/customers`,
    update: (id: string) => `${config.apiBaseUrl}/customers/${id}`,
    delete: (id: string) => `${config.apiBaseUrl}/customers/${id}`,
  },
  
  // Deployments
  deployments: {
    list: `${config.apiBaseUrl}/deployments`,
    detail: (id: string) => `${config.apiBaseUrl}/deployments/${id}`,
    create: `${config.apiBaseUrl}/deployments`,
    update: (id: string) => `${config.apiBaseUrl}/deployments/${id}`,
    status: (id: string) => `${config.apiBaseUrl}/deployments/${id}/status`,
  },
  
  // Policies
  policies: {
    list: `${config.apiBaseUrl}/policies`,
    detail: (id: string) => `${config.apiBaseUrl}/policies/${id}`,
    templates: `${config.apiBaseUrl}/policies/templates`,
  },

  // Entitlement mappings
  mappings: {
    featureCatalog: `${config.apiBaseUrl}/TCAdminFeatureCatalog`,
    featureCatalogByKey: (featureKey: string) => `${config.apiBaseUrl}/TCAdminFeatureCatalog/${featureKey}`,
    featureCatalogActivate: (featureKey: string) => `${config.apiBaseUrl}/TCAdminFeatureCatalog/${featureKey}/activate`,
    featureCatalogDeactivate: (featureKey: string) => `${config.apiBaseUrl}/TCAdminFeatureCatalog/${featureKey}/deactivate`,
    planMappings: `${config.apiBaseUrl}/TCAdminPlanFeatureMappings`,
    planMappingById: (id: number) => `${config.apiBaseUrl}/TCAdminPlanFeatureMappings/${id}`,
    planMappingActivate: (id: number) => `${config.apiBaseUrl}/TCAdminPlanFeatureMappings/${id}/activate`,
    planMappingDeactivate: (id: number) => `${config.apiBaseUrl}/TCAdminPlanFeatureMappings/${id}/deactivate`,
  },
} as const;

export default config;
